// @core/api/endpoints/secret/list_leases.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLeasesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List leases
 * Returns all active leases, optionally filtered by engine or status.
 */
export async function ListLeases(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    engine_id?: string | number | boolean;
    limit?: string | number | boolean;
    sort?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListLeasesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/leases`;
  const requestOptions = options;
  return client.get<ListLeasesResponse>(requestPath, { ...requestOptions, params });
}
